import PolicyStatusTag from './PolicyStatusTag'

export default PolicyStatusTag
